<style lang="scss" scoped>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}
.slide-fade-leave-active {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-leave-to {
  transform: scale(0.7);
  opacity: 0;
}
.slide-fade-enter
/* .slide-fade-leave-active below version 2.1.8 */ {
  transform: scale(1.3);
  opacity: 0;
}
</style>
<template>
  <div>
    <v-dialog v-model="loading" persistent width="300">
      <v-card color="primary" dark>
        <v-card-text>
          Aguarde...
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
    <v-app id="inspire">
      <v-navigation-drawer
        v-model="drawer"
        :clipped="$vuetify.breakpoint.lgAndUp"
        app
        color="secondary"
        dark
        expand-on-hover
      >
        <v-list nav dense>
          <template>
            <v-list-item link to="/">
              <v-list-item-action>
                <v-icon>mdi-view-dashboard</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Dashboard</v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-item link to="/budgets">
              <v-list-item-action>
                <v-icon>mdi-currency-usd</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Budgets</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </template>
        </v-list>
        <template v-slot:append>
          <v-list>
            <v-list-item link to="/logout">
              <v-list-item-action>
                <v-icon>mdi-logout</v-icon>
              </v-list-item-action>
              <v-list-item-content>
                <v-list-item-title>Logout</v-list-item-title>
              </v-list-item-content>
            </v-list-item>
          </v-list>
        </template>
      </v-navigation-drawer>
      <v-progress-linear
        indeterminate
        color="yellow darken-2"
      ></v-progress-linear>
      <v-app-bar :clipped-left="$vuetify.breakpoint.lgAndUp" app elevation="1">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <v-toolbar-title style="width: 300px" class="ml-0 pl-4">
          <h1>
            <v-img src="@/assets/logo.png" width="170px"></v-img>
          </h1>
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon>
          <v-icon>mdi-bell</v-icon>
        </v-btn>
        <v-menu :close-on-content-click="false" bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" class="mr-2" text>
              <v-avatar size="20">
                <v-img :src="language.country.flag_image_url">
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="grey lighten-5"
                        :size="25"
                        width="2"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                </v-img>
              </v-avatar>
            </v-btn>
          </template>
          <v-card max-width="300">
            <v-list dense>
              <v-list-item>
                <v-list-item-content>
                  <v-select
                    label="Idioma"
                    :value="language"
                    :items="languages"
                    :loading="changing_language"
                    @change="changeLanguage"
                    item-text="origin_name"
                    return-object
                  >
                    <template v-slot:item="{ item, on, attrs }">
                      <v-list-item v-bind="attrs" v-on="on">
                        <v-list-item-avatar>
                          <v-avatar size="20" class="mr-2">
                            <v-img :src="item.country.flag_image_url">
                              <template v-slot:placeholder>
                                <v-row
                                  class="fill-height ma-0"
                                  align="center"
                                  justify="center"
                                >
                                  <v-progress-circular
                                    indeterminate
                                    color="grey lighten-5"
                                    :size="25"
                                    width="2"
                                  ></v-progress-circular>
                                </v-row>
                              </template>
                            </v-img>
                          </v-avatar>
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title>{{
                            item.origin_name
                          }}</v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                    <template v-slot:selection="{ item }">
                      <v-avatar size="20" class="mr-2">
                        <v-img :src="item.country.flag_image_url">
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey lighten-5"
                                :size="25"
                                width="2"
                              ></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </v-avatar>
                      {{ item.origin_name }}
                    </template>
                  </v-select>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
        <v-menu :close-on-content-click="true" bottom offset-y>
          <template v-slot:activator="{ on }">
            <v-btn v-on="on" icon large>
              <user-avatar
                size="40"
                :user_name="user.name"
                :avatar_url="user.avatar"
              />
            </v-btn>
          </template>
          <v-card>
            <v-list dense>
              <v-list-item>
                <v-list-item-avatar class="mr-2">
                  <user-avatar
                    size="40"
                    :user_name="user.name"
                    :avatar_url="user.avatar"
                  />
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ user.name }}</v-list-item-title>
                  <v-list-item-subtitle>{{ user.email }}</v-list-item-subtitle>
                </v-list-item-content>
              </v-list-item>
            </v-list>
            <v-divider></v-divider>
            <v-list dense>
              <v-list-item to="perfil">
                <v-list-item-icon>
                  <v-icon>mdi-account-box</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Meu perfil</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
              <v-list-item to="/logout">
                <v-list-item-icon>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>Logout</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-card>
        </v-menu>
      </v-app-bar>
      <v-main id="app_content" style="background-color: #f1f1f1">
        <transition name="slide-fade">
          <router-view></router-view>
        </transition>
      </v-main>
      <v-snackbar
        v-model="snackbar.active"
        :timeout="5000"
        center
        top
        :color="snackbar.color || ''"
      >
        {{ snackbar.text }}
        <!-- <v-btn color="white" text @click="closeSnack">Fechar</v-btn> -->
      </v-snackbar>
    </v-app>
  </div>
</template>

<script>
import UserAvatar from "@/components/UserAvatar";
import { mapActions, mapState } from "vuex";

export default {
  name: "HelloWorld",
  components: {
    UserAvatar,
  },
  data: () => ({
    windowSize: {
      x: 0,
      y: 0,
    },
    dialog: false,
    drawer: null,
    items: [
      { icon: "mdi-view-dashboard", text: "Dashboard", link: "/" },
      {
        icon: "mdi-account-group",
        text: "Usuários",
        link: "/users",
        admin: true,
      },
    ],
  }),
  methods: {
    closeSnack() {
      this.$store.commit("closeMessage");
    },
    changeLanguage(language) {
      this.$store.dispatch("localization/changeLanguage", language);
    },
    ...mapActions("localization", ["loadLanguages"]),
  },
  created() {
    this.loadLanguages();
  },
  computed: {
    loading() {
      return this.$store.getters.getLoading;
    },
    user() {
      return this.$store.getters["auth/getUser"];
    },
    language() {
      return this.user.language || {};
    },
    snackbar() {
      return this.$store.getters.getSnackbar;
    },
    ...mapState("localization", ["languages", "changing_language"]),
  },
};
</script>
